import { NgModule } from '@angular/core';
import { PublishedReportPageComponent } from './published-report/published-report-page.component';
import { LoaderComponent } from '../../common/loader/loader.component';
import { DateComponent } from '../../common/fields/date/date.component';
import { SearchBarComponent } from '../../common/fields/search-bar/search-bar.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AuthFromSachComponent } from '../../common/auth-from-sach/auth-from-sach.component';
import { DataLoaderComponent } from '../../common/data-loader/data-loader.component';
import { DateSelectComponent } from '../../common/fields/date-select/date-select.component';
import { DropDownSingleSelectComponent } from '../../common/fields/drop-down-single-select/drop-down-single-select.component';
import { DropDownComponent } from '../../common/fields/drop-down/drop-down.component';
import { PaginationComponent } from '../../common/fields/pagination/pagination.component';
import { PistatusDropDownComponent } from '../../common/fields/pistatus-drop-down/pistatus-drop-down.component';
import { SearchNoteComponent } from '../../common/fields/search-note/search-note.component';
import { StatusDropDownComponent } from '../../common/fields/status-drop-down/status-drop-down.component';
import { HeaderComponent } from '../../common/header/header.component';
import { DataLoaderInterceptor } from '../../interceptors/data-loader.interceptor';
import { ErrorCatchingInterceptor } from '../../interceptors/error-catching.interceptor';
import { AuthModule } from '../login/auth.module';
import { AccountsMasterNewComponent } from './accounts-master-new/accounts-master-new.component';
import { AccountsMasterComponent } from './accounts-master/accounts-master.component';
import { AuthorAdvancesInvoiceGeneratedComponent } from './author-advances-invoice-generated/author-advances-invoice-generated.component';
import { AuthorBookInformationNewComponent } from './author-book-information-new/author-book-information-new.component';
import { AuthorBookInformationComponent } from './author-book-information/author-book-information.component';
import { AuthorEmailIdComponent } from './author-email-id/author-email-id.component';
import { BankAuthorsComponent } from './bank-authors/bank-authors.component';
import { ChapterwiseTitlesInProductionComponent } from './chapterwise-titles-in-production/chapterwise-titles-in-production.component';
import { DerivativeSourceProductComponent } from './derivative-source-product/derivative-source-product.component';
import { DevFdPendingAcceptanceComponent } from './dev-fd-pending-acceptance/dev-fd-pending-acceptance.component';
import { DevMyTitleComponent } from './dev-my-title/dev-my-title.component';
import { ExchangeRatesComponent } from './exchange-rates/exchange-rates.component';
import { FinanceAdvanceComponent } from './finance-advance/finance-advance.component';
import { FinanceRoyaltyRatesV1Component } from './finance-royalty-rates-v1/finance-royalty-rates-v1.component';
import { FinanceRoyaltyRatesV2Component } from './finance-royalty-rates-v2/finance-royalty-rates-v2.component';
import { ListReportComponent } from './list-report/list-report.component';
import { OsdLogNewComponent } from './osd-log-new/osd-log-new.component';
import { OsdLogComponent } from './osd-log/osd-log.component';
import { PipelineInfoComponent } from './pipeline-info/pipeline-info.component';
import { PpdDumpNewComponent } from './ppd-dump-new/ppd-dump-new.component';
import { PpdDumpComponent } from './ppd-dump/ppd-dump.component';
import { TimesheetComponent } from './timesheet/timesheet.component';
import { TitlesInProductionComponent } from './titles-in-production/titles-in-production.component';
import { TitlesPublishedComponent } from './titles-published/titles-published.component';
import { TotalRoyaltyProductComponent } from './total-royalty-product/total-royalty-product.component';
import { VideoLicensingPageComponent } from './video-licensing-page/video-licensing-page.component';
import { AuthorInformationComponent } from './author-information/author-information.component';
import { ReportsRoutingModule } from './reports.routing.module';
import { FooterComponent } from '../../common/footer/footer.component';
import { TradeSaleComponent } from './trade-sale/trade-sale.component';
import { SourceDerivativeProductComponent } from './source-derivative-product/source-derivative-product.component';

@NgModule({
  declarations: [
    PublishedReportPageComponent,
    LoaderComponent,
    DateComponent,
    SearchBarComponent,
    VideoLicensingPageComponent,
    HeaderComponent,
    DropDownComponent,
    SearchNoteComponent,
    StatusDropDownComponent,
    DevMyTitleComponent,
    PaginationComponent,
    DateSelectComponent,
    DropDownSingleSelectComponent,
    OsdLogComponent,

    ListReportComponent,
    PpdDumpComponent,
    FinanceRoyaltyRatesV1Component,
    AuthorBookInformationComponent,
    BankAuthorsComponent,
    DerivativeSourceProductComponent,
    FinanceAdvanceComponent,
    TotalRoyaltyProductComponent,
    AuthFromSachComponent,
    FinanceRoyaltyRatesV2Component,
    AccountsMasterComponent,
    ExchangeRatesComponent,
    PistatusDropDownComponent,
    TimesheetComponent,
    PipelineInfoComponent,
    AuthorAdvancesInvoiceGeneratedComponent,
    AuthorEmailIdComponent,
    DevFdPendingAcceptanceComponent,
    TitlesPublishedComponent,
    TitlesInProductionComponent,
    AccountsMasterNewComponent,
    ChapterwiseTitlesInProductionComponent,
    PpdDumpNewComponent,
    AuthorBookInformationNewComponent,
    OsdLogNewComponent,
    AuthorInformationComponent,
    FooterComponent,
    TradeSaleComponent,
    SourceDerivativeProductComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    NgbModule,
    NgMultiSelectDropDownModule.forRoot(),
    ReportsRoutingModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCatchingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DataLoaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [],
  exports: [
    PublishedReportPageComponent,
    LoaderComponent,
    DateComponent,
    SearchBarComponent,
    VideoLicensingPageComponent,
    HeaderComponent,
    DropDownComponent,
    SearchNoteComponent,
    StatusDropDownComponent,
    DevMyTitleComponent,
    PaginationComponent,
    DateSelectComponent,
    DropDownSingleSelectComponent,
    OsdLogComponent,
    ListReportComponent,
    PpdDumpComponent,
    FinanceRoyaltyRatesV1Component,
    AuthorBookInformationComponent,
    BankAuthorsComponent,
    DerivativeSourceProductComponent,
    FinanceAdvanceComponent,
    TotalRoyaltyProductComponent,
    AuthFromSachComponent,
    FinanceRoyaltyRatesV2Component,
    AccountsMasterComponent,
    ExchangeRatesComponent,
    PistatusDropDownComponent,
    TimesheetComponent,
    PipelineInfoComponent,
    AuthorAdvancesInvoiceGeneratedComponent,
    AuthorEmailIdComponent,
    DevFdPendingAcceptanceComponent,
    FooterComponent,
    TradeSaleComponent,
    SourceDerivativeProductComponent,
  ],
})
export class ReportsModule {}
